import React from 'react';

export interface SearchContextType {
	searchQuery: string;
	setSearchQuery: (query: string) => void;
	isSearchVisible: boolean;
	setIsSearchVisible: (visible: boolean) => void;
}

const SearchContext = React.createContext<SearchContextType | null>(null);

export const useSearch = () => {
	const context = React.useContext(SearchContext);
	if (!context) {
		throw new Error('useSearch must be used within a SearchProvider');
	}
	return context;
};

export const SearchProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [searchQuery, setSearchQuery] = React.useState('');
	const [isSearchVisible, setIsSearchVisible] = React.useState(false);

	return (
		<SearchContext.Provider value={{
			searchQuery,
			setSearchQuery,
			isSearchVisible,
			setIsSearchVisible,
		}}>
			{children}
		</SearchContext.Provider>
	);
};

